import { render, staticRenderFns } from "./ForumReactionsItem.vue?vue&type=template&id=30ea6d51&scoped=true"
import script from "./ForumReactionsItem.vue?vue&type=script&lang=js"
export * from "./ForumReactionsItem.vue?vue&type=script&lang=js"
import style0 from "./ForumReactionsItem.vue?vue&type=style&index=0&id=30ea6d51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea6d51",
  null
  
)

export default component.exports